export const INTELLIGENCE_MARKET = "Inteligencia de...";
export const TRADING_RANGES = "Rangos de neg...";
export const REVENUE_STANDARD = "Categoría Reve...";
